import { postAjax } from "./ajax.js";

export function loadSystemConfig() {
	let url = "api/Sys/GetSysConfigDic";
	postAjax(url, 1).then(data => {
		if (data.IsSucess) {
			window.systemData = data.Data;
		}
	});
}
export function exLoadSystemConfig() {
	return postAjax("api/Sys/GetSysConfigDic", 1);
}
export function SysKey(key) {
	if (window.systemData == null) {
		loadSystemConfig();
	}
	return window.systemData[key];
}

export default {
	exLoadSystemConfig,
	SysKey,
	loadSystemConfig,
};



// WEBPACK FOOTER //
// ./src/util/sysconfig.js